import {h, Fragment} from "preact"
import { useFacet, useProductFilters } from "@nosto/preact"
import { useEffect, useRef, useState, useMemo } from 'preact/hooks'
import { sizesOrder } from '../helpers'
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const { filters, removeAll } = useProductFilters()

    if(facet.name === 'Size') {
        facet.data.sort((a, b) => {
            const indexA = sizesOrder.indexOf(a.value);
            const indexB = sizesOrder.indexOf(b.value);
            if (indexA !== -1 && indexB !== -1) {
                return indexA - indexB;
            } else if (indexA === -1) {
                return 1;
            } else {
                return -1;
            }
        })
    }

    function clearFacet(){
        filters.map(filter => {
            filter.name === facet.name ? filter.remove() : ""
        })
    }

    

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <a
                class="ns-filter-block-title ns-d-flex ns-justify-content-between ns-relative ns-w-100 ns-border-box ns-text-undecorated"
                href="javascript:void(0)"
                data-nosto-element="facet"
            >
                <span class="ns-filter-block-name" onClick={toggleActive}>{facet.name}</span>
                {selectedFiltersCount > 0 && (
                    <a href="javascript:void(0)" class="ns-filter-clear" onClick={clearFacet}>Clear</a>
                )}
            </a>
            <div class="ns-filter-option-block">
                <div class="ns-filter-container">
                    <div class="ns-filter-panel">
                        <div class="ns-sidebar-submenu ns-d-none">
                            <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                                {facet.data?.map(value => (
                                    <li
                                        class={`ns-filter-value ns-d-flex ns-justify-content-between ns-align-items-center ${value.selected ? "ns-selected" : ""}`}
                                        data-nosto-element="facet-setting"
                                    >
                                        <Checkbox
                                            value={value.value}
                                            selected={value.selected}
                                            onChange={e => {
                                                e.preventDefault()
                                                toggleProductFilter(facet.field, value.value, !value.selected)
                                            }}
                                        />
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </li>
    )
}
